import { createPostRequest } from '_helpers';

export async function getFileStatus( values ) {
    return createPostRequest("filestatus_getData", values)
        .then(res => res.data)
        .then(({ success, data, errorMsg, redirect = false }) => {
            return { response: success, data, errorMsg, redirect };
        })
}